export default function stripHttpStatusSuffix(message: string): string {
	return message.replace(/ \[\d{3}\]$/, '');
}
